import { Component, OnInit } from '@angular/core';
import { BannerService, VideoPantalla } from '../services/banner.service';
import { SucursalApi } from '../shared/lb-sdk';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-abm-banners',
  templateUrl: './abm-banners.component.html',
  styleUrls: ['./abm-banners.component.scss']
})
export class AbmBannersComponent implements OnInit {
  banners: VideoPantalla[] = [];
  bannersTodos: VideoPantalla[] = [];
  soloVideos = false;
  soloActivos = false;
  editando: VideoPantalla = null;
  archivoSeleccionado: File = null;
  previewUrl: string = null;
  sucursalesDB: any[] = [];

  form: VideoPantalla = this.nuevoFormulario();

  constructor(
    private bannerService: BannerService,
    private sucursalApi: SucursalApi,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.sucursalApi.find().subscribe(res => {
      this.sucursalesDB = [{ idsucursal: null, nombre: 'Todas las sucursales' }, ...res];
    });
    this.cargar();
  }

  nuevoFormulario(): VideoPantalla {
    return {
      nombre: '',
      url: '',
      esVideo: 0,
      orden: 0,
      activo: 1
    };
  }

  cargar(): void {
    this.spinner.show();
    this.bannerService.listar().subscribe(
      data => {
        this.bannersTodos = data;
        this.aplicarFiltro();
        this.spinner.hide();
      },
      () => {
        this.spinner.hide();
        this.toastr.error('No se pudieron cargar los videos/banners');
      }
    );
  }

  nuevo(): void {
    this.editando = null;
    this.form = this.nuevoFormulario();
    this.archivoSeleccionado = null;
    this.previewUrl = null;
  }

  editar(video: VideoPantalla): void {
    this.editando = video;
    this.form = { ...video, esVideo: 0 };
    this.archivoSeleccionado = null;
    this.previewUrl = this.bannerService.resolverUrl(video.url);
  }

  onArchivo(event: any): void {
    const file = event.target.files[0];
    if (!file) {
      return;
    }
    this.archivoSeleccionado = file;
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.previewUrl = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  guardar(): void {
    if (!this.form.nombre || !this.form.nombre.trim()) {
      this.toastr.warning('Ingrese un nombre');
      return;
    }

    this.spinner.show();

    const guardarVideo = (url: string) => {
      const payload: VideoPantalla = {
        ...this.form,
        url: this.bannerService.normalizarRuta(url),
        activo: this.form.activo ? 1 : 0,
        esVideo: 0
      };

      if (!payload.idSucursal) {
        delete payload.idSucursal;
      }

      if (this.editando && this.editando.idvideo) {
        this.bannerService.actualizar(this.editando.idvideo, payload).subscribe(
          () => {
            this.spinner.hide();
            this.toastr.success('Registro actualizado');
            this.nuevo();
            this.cargar();
          },
          () => {
            this.spinner.hide();
            this.toastr.error('Error al actualizar');
          }
        );
      } else {
        if (!url) {
          this.spinner.hide();
          this.toastr.warning('Seleccione una imagen o video');
          return;
        }
        this.bannerService.crear(payload).subscribe(
          () => {
            this.spinner.hide();
            this.toastr.success('Registro creado');
            this.nuevo();
            this.cargar();
          },
          () => {
            this.spinner.hide();
            this.toastr.error('Error al crear');
          }
        );
      }
    };

    if (this.archivoSeleccionado) {
      this.bannerService.subirArchivo(this.archivoSeleccionado).subscribe(
        url => guardarVideo(url),
        () => {
          this.spinner.hide();
          this.toastr.error('Error al subir el archivo');
        }
      );
    } else if (this.editando && this.form.url) {
      guardarVideo(this.form.url);
    } else {
      this.spinner.hide();
      this.toastr.warning('Seleccione una imagen o video');
    }
  }

  eliminar(video: VideoPantalla): void {
    const nombre = video.nombre || video.url;
    if (!confirm('¿Eliminar "' + nombre + '"?')) {
      return;
    }
    this.spinner.show();
    this.bannerService.eliminar(video.idvideo).subscribe(
      () => {
        this.spinner.hide();
        this.toastr.success('Registro eliminado');
        this.cargar();
      },
      () => {
        this.spinner.hide();
        this.toastr.error('Error al eliminar');
      }
    );
  }

  toggleActivo(video: VideoPantalla): void {
    this.bannerService.actualizar(video.idvideo, { activo: video.activo ? 0 : 1 }).subscribe(
      () => this.cargar(),
      () => this.toastr.error('Error al cambiar estado')
    );
  }

  aplicarFiltro(): void {
    let resultado = this.bannersTodos;

    if (this.soloVideos) {
      resultado = resultado.filter(b => b.esVideo === 1);
    } else {
      resultado = resultado.filter(b => b.esVideo !== 1);
    }

    if (this.soloActivos) {
      resultado = resultado.filter(b => b.activo === 1);
    }

    this.banners = resultado;
  }

  textoTipo(esVideo: number): string {
    return esVideo === 1 ? 'Video lateral (display-tv)' : 'Banner footer (display-tv-v2)';
  }

  urlMedia(url: string): string {
    return this.bannerService.resolverUrl(url);
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/abm-banners/abm-banners.component.ts